import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const TIPOS_ADMIN = ["Soporte", "Moderador", "Contador", "Administrador"];

const TIPO_CFG = {
    SuperAdmin:    { cls: "bg-dark text-white",                                                           icono: "bi-shield-fill-check"   },
    Administrador: { cls: "bg-primary-subtle text-primary-emphasis border border-primary-subtle",         icono: "bi-shield-fill"         },
    Contador:      { cls: "bg-success-subtle text-success-emphasis border border-success-subtle",         icono: "bi-calculator-fill"     },
    Moderador:     { cls: "bg-warning-subtle text-warning-emphasis border border-warning-subtle",         icono: "bi-eye-fill"            },
    Soporte:       { cls: "bg-info-subtle text-info-emphasis border border-info-subtle",                  icono: "bi-headset"             },
};

const FORM_INICIAL = { nombre: "", apellido: "", username: "", correo: "", tipo: "", contrasena: "" };

function fmtFecha(f) {
    if (!f) return "—";
    return new Date(f).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" });
}

function RegistrarAdministrador() {
    const [form, setForm]           = useState(FORM_INICIAL);
    const [cargando, setCargando]   = useState(false);
    const [verPass, setVerPass]     = useState(false);
    const [admins, setAdmins]       = useState([]);
    const [cargandoLista, setCargandoLista] = useState(true);

    const cargarAdmins = useCallback(async () => {
        try {
            setCargandoLista(true);
            const res = await axios.post("/listar-administradores");
            if (res.data.exito) setAdmins(res.data.admins);
        } catch { /* silencioso */ } finally { setCargandoLista(false); }
    }, []);

    useEffect(() => { cargarAdmins(); }, [cargarAdmins]);

    function cambiarCampo(campo, valor) {
        setForm((prev) => ({ ...prev, [campo]: valor }));
    }

    async function registrar(e) {
        e.preventDefault();

        if (!form.nombre.trim() || !form.apellido.trim() || !form.username.trim() || !form.correo.trim() || !form.tipo || !form.contrasena) {
            return Swal.fire({ icon: "error", title: "Datos incompletos", text: "Por favor completa todos los campos." });
        }
        if (form.username.trim().length < 4) {
            return Swal.fire({ icon: "error", title: "Usuario muy corto", text: "El usuario debe tener al menos 4 caracteres." });
        }
        if (!/^[a-z0-9_]+$/.test(form.username.trim())) {
            return Swal.fire({ icon: "error", title: "Usuario inválido", text: "El usuario solo puede tener letras, números y guión bajo (_). Sin espacios ni símbolos." });
        }
        if (form.contrasena.length < 6) {
            return Swal.fire({ icon: "error", title: "Contraseña muy corta", text: "La contraseña debe tener al menos 6 caracteres." });
        }

        try {
            setCargando(true);
            const res = await axios.post("/registrar-administrador", {
                params: {
                    nombre:     form.nombre.trim(),
                    apellido:   form.apellido.trim(),
                    username:   form.username.trim().toLowerCase(),
                    correo:     form.correo.trim(),
                    tipo:       form.tipo,
                    contrasena: form.contrasena,
                },
            });

            if (res?.data?.exito) {
                await Swal.fire({ icon: "success", title: "Administrador creado", text: res.data.mensaje || "Cuenta creada exitosamente.", timer: 2500, showConfirmButton: false });
                setForm(FORM_INICIAL);
                cargarAdmins();
            } else {
                Swal.fire({ icon: "error", title: "Error", text: res?.data?.mensaje || "No se pudo registrar el administrador." });
            }
        } catch (err) {
            Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.mensaje || "Ocurrió un error. Intenta de nuevo." });
        } finally {
            setCargando(false);
        }
    }

    return (
        <div className="container-fluid pb-5">
            <div className="d-flex justify-content-between flex-wrap align-items-center pt-3 pb-2 mb-4 border-bottom gap-2">
                <div>
                    <h1 className="h4 fw-bold text-dark mb-0">Administradores</h1>
                    <p className="text-muted mb-0 small mt-1">Crea y consulta las cuentas con rol administrativo.</p>
                </div>
            </div>

            <div className="row g-4 align-items-start">

                {/* ── Formulario ── */}
                <div className="col-12 col-lg-5 col-xl-4">
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4" style={{ fontSize: "0.92rem" }}>
                                <i className="bi bi-person-plus-fill me-2 text-primary"></i>Nuevo administrador
                            </h6>

                            <form onSubmit={registrar} noValidate>
                                <div className="d-flex flex-column gap-3">
                                    <div className="row g-2">
                                        <div className="col-6">
                                            <div className="form-floating">
                                                <input type="text" className="form-control" placeholder="Nombre"
                                                    value={form.nombre} onChange={(e) => cambiarCampo("nombre", e.target.value)}
                                                    disabled={cargando} required />
                                                <label>Nombre</label>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-floating">
                                                <input type="text" className="form-control" placeholder="Apellido"
                                                    value={form.apellido} onChange={(e) => cambiarCampo("apellido", e.target.value)}
                                                    disabled={cargando} required />
                                                <label>Apellido</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-floating">
                                        <input type="text" className="form-control" placeholder="Usuario"
                                            value={form.username}
                                            onChange={(e) => cambiarCampo("username", e.target.value.replace(/[^a-z0-9_]/g, "").toLowerCase())}
                                            disabled={cargando} required />
                                        <label><i className="bi bi-at me-1"></i>Usuario</label>
                                    </div>

                                    <div className="form-floating">
                                        <input type="email" className="form-control" placeholder="Correo"
                                            value={form.correo} onChange={(e) => cambiarCampo("correo", e.target.value)}
                                            disabled={cargando} required />
                                        <label>Correo electrónico</label>
                                    </div>

                                    <div className="form-floating">
                                        <select className="form-select" value={form.tipo}
                                            onChange={(e) => cambiarCampo("tipo", e.target.value)}
                                            disabled={cargando} required>
                                            <option value="">Selecciona un rol…</option>
                                            {TIPOS_ADMIN.map((t) => <option key={t} value={t}>{t}</option>)}
                                        </select>
                                        <label>Rol</label>
                                    </div>

                                    <div className="input-group">
                                        <div className="form-floating flex-grow-1">
                                            <input type={verPass ? "text" : "password"} className="form-control rounded-end-0"
                                                placeholder="Contraseña temporal"
                                                value={form.contrasena} onChange={(e) => cambiarCampo("contrasena", e.target.value)}
                                                disabled={cargando} required />
                                            <label>Contraseña temporal</label>
                                        </div>
                                        <button type="button" className="btn btn-outline-secondary" tabIndex={-1}
                                            onClick={() => setVerPass((v) => !v)}>
                                            <i className={`bi ${verPass ? "bi-eye-slash" : "bi-eye"}`}></i>
                                        </button>
                                    </div>
                                    <div className="text-muted" style={{ fontSize: "0.75rem", marginTop: -8 }}>
                                        <i className="bi bi-info-circle me-1"></i>Comparte esta contraseña con el nuevo administrador.
                                    </div>

                                    <button type="submit" className="btn btn-primary w-100 py-2" disabled={cargando}>
                                        {cargando ? (
                                            <><span className="spinner-border spinner-border-sm me-2"></span>Registrando…</>
                                        ) : (
                                            <><i className="bi bi-person-check-fill me-2"></i>Crear administrador</>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* ── Lista de admins ── */}
                <div className="col-12 col-lg-7 col-xl-8">
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                        <div className="card-header bg-white border-0 p-4 d-flex justify-content-between align-items-center">
                            <div>
                                <h6 className="fw-bold text-dark mb-0" style={{ fontSize: "0.92rem" }}>
                                    <i className="bi bi-shield-fill me-2 text-primary"></i>Equipo actual
                                </h6>
                                <p className="text-muted small mb-0 mt-1">Cuentas con acceso al panel administrativo.</p>
                            </div>
                            <span className="badge rounded-pill bg-light text-dark border px-3 py-2">{admins.length} cuentas</span>
                        </div>

                        {cargandoLista ? (
                            <div className="text-center py-5 text-muted">
                                <span className="spinner-border spinner-border-sm me-2"></span>Cargando…
                            </div>
                        ) : admins.length === 0 ? (
                            <div className="p-5 text-center text-muted">
                                <i className="bi bi-people fs-2 d-block mb-2" style={{ opacity: 0.3 }}></i>
                                <span className="small">No hay administradores registrados.</span>
                            </div>
                        ) : (
                            <>
                                {/* Tabla escritorio */}
                                <div className="d-none d-md-block">
                                    <table className="table table-hover align-middle mb-0" style={{ fontSize: "0.85rem" }}>
                                        <thead className="table-light">
                                            <tr>
                                                <th className="ps-4 fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Usuario</th>
                                                <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Correo</th>
                                                <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Rol</th>
                                                <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Desde</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {admins.map((a) => {
                                                const cfg  = TIPO_CFG[a.tipo] || TIPO_CFG.Soporte;
                                                const nombre = [a.nombre, a.apellido].filter(Boolean).join(" ") || a.username || "—";
                                                return (
                                                    <tr key={a._id}>
                                                        <td className="ps-4">
                                                            <div className="d-flex align-items-center gap-3">
                                                                <img
                                                                    src={a.avatar && a.avatar !== "NA" ? a.avatar : "/imagenes/marca/avatar.png"}
                                                                    alt={nombre}
                                                                    className="rounded-circle flex-shrink-0"
                                                                    style={{ width: 36, height: 36, objectFit: "cover" }}
                                                                />
                                                                <div style={{ lineHeight: 1.3 }}>
                                                                    <div className="fw-semibold text-dark">{nombre}</div>
                                                                    <div className="text-muted" style={{ fontSize: "0.72rem" }}>@{a.username || "—"}</div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="text-muted small">{a.email || "—"}</td>
                                                        <td>
                                                            <span className={`badge rounded-pill px-2 py-1 ${cfg.cls}`} style={{ fontSize: "0.7rem" }}>
                                                                <i className={`bi ${cfg.icono} me-1`}></i>{a.tipo}
                                                            </span>
                                                        </td>
                                                        <td className="text-muted small">{fmtFecha(a.createdAt)}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Lista móvil */}
                                <div className="d-md-none list-group list-group-flush">
                                    {admins.map((a) => {
                                        const cfg    = TIPO_CFG[a.tipo] || TIPO_CFG.Soporte;
                                        const nombre = [a.nombre, a.apellido].filter(Boolean).join(" ") || a.username || "—";
                                        return (
                                            <div key={a._id} className="list-group-item px-4 py-3">
                                                <div className="d-flex align-items-center gap-3">
                                                    <img
                                                        src={a.avatar && a.avatar !== "NA" ? a.avatar : "/imagenes/marca/avatar.png"}
                                                        alt={nombre}
                                                        className="rounded-circle flex-shrink-0"
                                                        style={{ width: 40, height: 40, objectFit: "cover" }}
                                                    />
                                                    <div className="flex-grow-1 min-w-0">
                                                        <div className="fw-semibold text-dark text-truncate">{nombre}</div>
                                                        <div className="text-muted" style={{ fontSize: "0.72rem" }}>@{a.username} · {a.email}</div>
                                                    </div>
                                                    <span className={`badge rounded-pill px-2 py-1 flex-shrink-0 ${cfg.cls}`} style={{ fontSize: "0.7rem" }}>
                                                        <i className={`bi ${cfg.icono} me-1`}></i>{a.tipo}
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default RegistrarAdministrador;
